<mat-expansion-panel>
  <mat-expansion-panel-header>
    <mat-panel-title data-cy="detail-header">Carbon Offset Site Information</mat-panel-title>
  </mat-expansion-panel-header>

  <mat-divider></mat-divider>

  @if (site) {
    <div class="section-content">
      <fc-site-detail-overview
        [readOnly]="!isAdmin && !isSuperAdmin"
        [isSuperAdmin]="isSuperAdmin"></fc-site-detail-overview>
      <mat-divider></mat-divider>
      <table [dataSource]="parcelData" class="fc-table" mat-table aria-describedby="List of Parcels">
        <ng-container matColumnDef="parcelNum">
          <th scope="col" *matHeaderCellDef mat-header-cell>Parcel Number</th>
          <td *matCellDef="let parcelElement" mat-cell>
            @if (isAdmin) {
              <fa-icon
                (click)="siteHelper.updateParcelMetadata(site, parcelElement)"
                [icon]="['far', 'pen-to-square']"
                class="blue edit-parcel"></fa-icon>
            }
            {{ parcelElement.parcelNumber }}
          </td>
        </ng-container>
        <ng-container matColumnDef="owner">
          <th scope="col" *matHeaderCellDef mat-header-cell>Owner Name</th>
          <td *matCellDef="let parcelElement" mat-cell>
            {{ parcelElement.owner }}
          </td>
        </ng-container>
        <ng-container matColumnDef="address">
          <th scope="col" *matHeaderCellDef mat-header-cell>Address</th>
          <td *matCellDef="let parcelElement" mat-cell>
            {{ parcelElement.address }}
          </td>
        </ng-container>
        <ng-container matColumnDef="county">
          <th scope="col" *matHeaderCellDef mat-header-cell>County</th>
          <td *matCellDef="let parcelElement" mat-cell>
            {{ parcelElement.county }}
          </td>
        </ng-container>
        <ng-container matColumnDef="state">
          <th scope="col" *matHeaderCellDef mat-header-cell>State</th>
          <td *matCellDef="let parcelElement" mat-cell>
            {{ parcelElement.state }}
          </td>
        </ng-container>
        <tr *matHeaderRowDef="displayedColumns" mat-header-row></tr>
        <tr *matRowDef="let row; columns: displayedColumns" mat-row></tr>
      </table>
      <mat-divider></mat-divider>
      <div class="section-header spaced">Eligibility Questions</div>
      <div [ngClass]="getQuestionClass('hasRestrictions')">
        @if (flagQuestion('hasRestrictions') && isAdmin) {
          <fa-icon
            [icon]="['far', 'flag']"
            class="red flag-image"></fa-icon>
        }
        Is this acreage encumbered by a deed, mortgage or legal restriction that impacts the timber on this acreage?
        <span class="answer">
          {{ getBooleanString(site.hasRestrictions) }}
        </span>
      </div>
      <div [ngClass]="getQuestionClass('hasLeakage')">
        @if (flagQuestion('hasLeakage') && isAdmin) {
          <fa-icon [icon]="['far', 'flag']" class="red flag-image"></fa-icon>
        }
        <span>
          Do you own forests outside of the selected stands in your carbon offset site, and if so, do you plan to conduct
          timber harvests in those areas that total 40 acres or more in a single stand or group of stands?
          <br />
          <br />
          @if (site && site.periodicReports[0] && site.periodicReports[0].leakageInfo) {
            <span>
              <strong>Details:</strong>
              {{ site.periodicReports[0].leakageInfo }}
            </span>
          }
        </span>
        <span class="answer">
          {{ getBooleanString(site && site.periodicReports[0] && site.periodicReports[0].activityLeakage) }}
        </span>
      </div>
      <div [ngClass]="getQuestionClass('programs')">
        @if (flagQuestion('programs') && isAdmin) {
          <fa-icon [icon]="['far', 'flag']" class="red flag-image"></fa-icon>
        }
        Is this acreage included in any other program(s)?
        <span class="answer">
          {{ getBooleanString(site.programs && site.programs.length > 0) }}
        </span>
      </div>
      @if (programs.length > 0) {
        <div class="alert-container">
          <div class="indented section-header">Other Carbon Programs</div>
          <ul class="program-tiles-container">
            @for (program of programs; track program) {
              <li class="program-tile">
                @if (isAdmin && program.restrictionLevel === -1) {
                  <div>
                    <fa-icon [icon]="['fas', 'question']" class="blue"></fa-icon>
                  </div>
                }
                @if (isAdmin && program.restrictionLevel === 0) {
                  <div>
                    <fa-icon [icon]="['fas', 'circle']" class="green"></fa-icon>
                  </div>
                }
                @if (isAdmin && program.restrictionLevel === 1) {
                  <div>
                    <fa-icon [icon]="['fas', 'triangle']" class="yellow"></fa-icon>
                  </div>
                }
                @if (isAdmin && program.restrictionLevel === 2) {
                  <div>
                    <fa-icon [icon]="['fas', 'octagon']" class="red"></fa-icon>
                  </div>
                }
                {{ program.name }}
                @if (!program.isActive) {
                  <span class="inactive">(Inactive)</span>
                }
              </li>
            }
          </ul>
        </div>
      }
      <mat-divider class="spaced"></mat-divider>
    </div>
  }
</mat-expansion-panel>
